import React, { useEffect } from 'react';

import { trackerManager } from '@hero/clients';
import { configs } from '@hero/configs';
import { TRACKER_EVENT } from '@hero/constants';
import { storage } from '@hero/utils';

import { DataDashboard } from './DataDashboard';
import { DefaultDashboard } from './DefaultDashboard';

const componentNameByVariant = {
  data: DataDashboard,
  default: DefaultDashboard
};

export function DashboardTemplate(props) {
  useEffect(() => {
    if (storage.getSsoLogin()) {
      storage.updateSsoLogin(false);
      trackerManager.emit(TRACKER_EVENT.login);
    }
  }, []);

  const variant = configs.dashboard?.variant || 'default';

  const LazyComponent = componentNameByVariant[variant];

  return <LazyComponent {...props} />;
}
